'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var CONTENT_PADDING = {
    NORMAL: 'normal',
    NONE: 'none'
};

var Module = function Module(_ref) {
    var children = _ref.children,
        className = _ref.className,
        roundedCorners = _ref.roundedCorners,
        contentPadding = _ref.contentPadding,
        rest = _objectWithoutProperties(_ref, ['children', 'className', 'roundedCorners', 'contentPadding']);

    var classNames = (0, _classnames2.default)('cc-module-comp', className, {
        rounded: roundedCorners,
        'content-padding-normal': contentPadding === CONTENT_PADDING.NORMAL,
        'content-padding-none': contentPadding === CONTENT_PADDING.NONE
    });
    return _react2.default.createElement(
        'div',
        Object.assign({
            className: classNames
        }, rest),
        children
    );
};

Module.propTypes = {
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    roundedCorners: _propTypes2.default.bool,
    contentPadding: _propTypes2.default.oneOf((0, _values2.default)(CONTENT_PADDING))
};
Module.defaultProps = {
    roundedCorners: false,
    contentPadding: CONTENT_PADDING.NORMAL
};

exports.default = Module;
//# sourceMappingURL=index.js.map